var map = {
	"./assets/adv/advertising_ascending_default@2x.png": "INh4",
	"./assets/adv/advertising_ascending_selected@2x.png": "nrft",
	"./assets/adv/advertising_category01@2x.png": "Dbsq",
	"./assets/adv/advertising_category02@2x.png": "jkqq",
	"./assets/adv/advertising_delete@2x.png": "PdNh",
	"./assets/adv/advertising_descending_default@2x.png": "9e/H",
	"./assets/adv/advertising_descending_selected@2x.png": "1UxR",
	"./assets/adv/advertising_edit@2x.png": "1kvn",
	"./assets/adv/advertising_phone@2x.png": "7lko",
	"./assets/home/all_icon_logo@2x.png": "gP9l",
	"./assets/home/home_login_delete@2x.png": "+6WX",
	"./assets/home/home_login_e-mail@2x.png": "BoXY",
	"./assets/home/home_login_key@2x.png": "SeA6",
	"./assets/icon/all_icon_checkbox_default@2x.png": "S+0V",
	"./assets/icon/all_icon_checkbox_disabled@2x.png": "OuJM",
	"./assets/icon/all_icon_checkbox_selected@2x.png": "yMTv",
	"./assets/icon/all_icon_correct@2x.png": "CG1M",
	"./assets/icon/all_icon_error@2x.png": "9Bbq",
	"./assets/icon/all_icon_open_default@2x.png": "z+7F",
	"./assets/icon/all_icon_open_selected@2x.png": "g8hf",
	"./assets/icon/all_popup_icon_correct@2x.png": "rue3",
	"./assets/icon/all_popup_icon_delete@2x.png": "N2p3",
	"./assets/icon/all_popup_icon_risk@2x.png": "ZdaP",
	"./assets/icon/all_popup_icon_waiting@2x.png": "j92O",
	"./assets/icon/search@2x.png": "I3qo",
	"./assets/icon/upload@2x.png": "DmlL",
	"./assets/nav/all_icon_nav_advertising_default@2x.png": "3V7I",
	"./assets/nav/all_icon_nav_advertising_selected@2x.png": "Iuow",
	"./assets/nav/all_icon_nav_consumption statement_default@2x.png": "upor",
	"./assets/nav/all_icon_nav_consumption statement_selected@2x.png": "7W2d",
	"./assets/nav/all_icon_nav_my account_default@2x.png": "IYQH",
	"./assets/nav/all_icon_nav_my account_selected@2x.png": "H7xk",
	"./assets/nav/all_icon_nav_survey_default@2x.png": "lDme",
	"./assets/nav/all_icon_nav_survey_selected@2x.png": "DU15",
	"./assets/pics/all_icon_no result@2x.png": "wIBx",
	"./assets/pics/my account_recharge_alipay@2x.png": "ANfF",
	"./assets/pics/my account_recharge_unionpay@2x.png": "n+G6",
	"./assets/pics/my account_recharge_weixin@2x.png": "LC73",
	"./assets/survey/survey_add ad@2x.png": "AQtP",
	"./assets/user/all_icon_correct@2x.png": "eQIw",
	"./assets/user/all_popup_icon_correct@2x.png": "Cg5o",
	"./assets/user/all_popup_icon_waiting@2x.png": "t8by"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2W5f";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/assets.*@2x\.png$
// module id = 2W5f
// module chunks = 1